import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    title: 'Bot is not available',
    description: "Remove other bots' names from your Telegram name, otherwise the ban will be permanent.",
  },
  ru: {
    title: 'Бот тебе не доступен',
    description: 'Убери имена других ботов из своего имени в Telegram, иначе бан будет навсегда.',
  },
  uz: {
    title: 'Bot siz uchun mavjud emas',
    description: "Telegram ismingizdan boshqa botlarning nomlarini olib tashlang, aks holda ban abadiy bo'ladi.",
  },
});
